
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articles/categories/[...slugs]",
      function () {
        return require("private-next-pages/articles/categories/[...slugs].page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/articles/categories/[...slugs]"])
      });
    }
  